import React from "react";
import { useMutation } from "@tanstack/react-query";

import api from "../../api";

const fetcher = api();

export default function useTeacherReferralMutation(options = {}) {
  const [referTeacherError, setReferTeacherError] = React.useState(null);
  const {
    mutate: referTeacher,
    isPending: isReferTeacherLoading,
  } = useMutation({
    mutationFn: ({ email }) => fetcher.referTeacherViaEmail(email),
    ...options,
    onMutate: () => {
      options.onMutate?.();

      setReferTeacherError(null);
    },
    onError: async (error) => {
      try {
        options.onError?.(error);
        const { error: message } = await error.response.json();
        setReferTeacherError(message);
      } catch {
        setReferTeacherError("Something went wrong, please try again");
      }
    },
  });

  return {
    referTeacher,
    isReferTeacherLoading,
    referTeacherError,
  };
}
